import React from 'react';
import PropTypes from 'prop-types';

function ActivityItem({ 
  icon = 'fa-user-check',
  iconColor = '#a855f7',
  title = '',
  description = '',
  timestamp = '',
  bgColor = '#faf5ff',
  borderColor = '#e9d5ff'
}) {
  return (
    <div className="activity-item p-3" style={{ backgroundColor: bgColor, borderRadius: '8px', border: `1px solid ${borderColor}` }}>
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex align-items-start">
          <div className="me-3" style={{ 
            width: '32px', 
            height: '32px', 
            borderRadius: '50%',
            backgroundColor: '#f3e8ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <i className={`fas ${icon}`} style={{ color: iconColor, fontSize: '14px' }}></i>
          </div>
          <div>
            <p className="mb-1 fw-semibold small">{title}</p>
            <p className="text-muted small mb-0">{description}</p>
          </div>
        </div>
        <i className="fas fa-chevron-right text-muted" style={{ fontSize: '12px' }}></i>
      </div>
      <div className="text-end mt-2">
        <small className="text-muted" style={{ fontSize: '11px' }}>{timestamp}</small>
      </div>
    </div>
  );
}

ActivityItem.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  timestamp: PropTypes.string,
  bgColor: PropTypes.string,
  borderColor: PropTypes.string
};

export default ActivityItem;